import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Auth.css';

const TermsAndConditions = () => {
  return (
    <div className="auth-container">
      <div className="terms-card">
        <h1>Wiki Game</h1>
        <h2>Terms &amp; Conditions</h2>
        <p className="terms-updated">Last updated: April 2026</p>

        <div className="terms-content">
          <section>
            <h3>1. Acceptance of Terms</h3>
            <p>
              By creating an account and using Wiki Game ("the Platform"), you agree to be bound by these
              Terms &amp; Conditions. If you do not agree, you must not register or use the Platform.
            </p>
          </section>

          <section>
            <h3>2. Eligibility</h3>
            <p>
              You must be at least 18 years old to use this Platform. By registering, you confirm that you
              are of legal age and have the legal capacity to enter into a binding agreement.
            </p>
          </section>

          <section>
            <h3>3. Account Registration</h3>
            <p>
              You agree to provide accurate, complete, and up-to-date information during registration.
              You are responsible for maintaining the confidentiality of your account credentials.
              Any activity that occurs under your account is your responsibility.
            </p>
          </section>

          <section>
            <h3>4. Wagers &amp; Virtual Currency</h3>
            <p>
              The Platform uses "Wikipenny" as its virtual currency for wagers and transactions.
              All wagers placed are final once a game begins. Refunds are only issued in cases of
              verified technical failure. The Platform reserves the right to void any wager that
              violates these terms or is suspected of fraud.
            </p>
          </section>

          <section>
            <h3>5. Fair Play</h3>
            <p>
              You agree not to use bots, scripts, exploits, or any automated tools to gain an unfair
              advantage. Collusion with other players to manipulate game outcomes is strictly prohibited.
              Violations may result in immediate account suspension, forfeiture of balance, and a
              permanent ban.
            </p>
          </section>

          <section>
            <h3>6. Platform Fees</h3>
            <p>
              The Platform charges a service fee (rake/charge) on wagered games. The current fee
              percentage is displayed before you confirm any wager. The Platform reserves the right
              to adjust fees with prior notice.
            </p>
          </section>

          <section>
            <h3>7. Deposits &amp; Withdrawals</h3>
            <p>
              Deposits are credited to your account balance upon confirmation. Withdrawal requests
              are subject to identity verification and processing times. The Platform reserves the
              right to request additional verification documents before processing withdrawals.
              Minimum deposit and withdrawal amounts apply as displayed on the Platform.
            </p>
          </section>

          <section>
            <h3>8. Referral Programme</h3>
            <p>
              Users may earn bonuses by referring new players via their unique referral code.
              Self-referral, fake accounts, or abuse of the referral system will result in
              forfeiture of bonuses and potential account suspension.
            </p>
          </section>

          <section>
            <h3>9. Privacy &amp; Data</h3>
            <p>
              We collect personal information (name, email, phone, device fingerprint) to operate
              the Platform, prevent fraud, and improve your experience. We do not sell your personal
              data to third parties. Data is stored securely and access is restricted to authorised
              personnel only.
            </p>
          </section>

          <section>
            <h3>10. Intellectual Property</h3>
            <p>
              All content, design, code, and branding on the Platform are the property of Wiki Game.
              You may not copy, reproduce, or distribute any part of the Platform without prior
              written consent.
            </p>
          </section>

          <section>
            <h3>11. Limitation of Liability</h3>
            <p>
              The Platform is provided "as is" without warranties of any kind. We are not liable for
              any losses resulting from connectivity issues, server downtime, or third-party service
              failures. Your use of the Platform is at your own risk.
            </p>
          </section>

          <section>
            <h3>12. Account Termination</h3>
            <p>
              We reserve the right to suspend or permanently ban any account that violates these
              terms, engages in fraudulent activity, or disrupts the Platform. You may also request
              account deletion by contacting support.
            </p>
          </section>

          <section>
            <h3>13. Modifications</h3>
            <p>
              We may update these Terms &amp; Conditions at any time. Continued use of the Platform
              after changes are posted constitutes acceptance of the revised terms.
            </p>
          </section>

          <section>
            <h3>14. Contact</h3>
            <p>
              For questions about these terms or the Platform, please contact us through the
              support channels available on the Platform.
            </p>
          </section>
        </div>

        <div className="terms-footer">
          <Link to="/register" className="terms-back-link">← Back to Registration</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
